import React, { useState } from "react";
import {
  Editor,
  EditorState,
  RichUtils,
  ContentState,
} from "draft-js";
import "draft-js/dist/Draft.css";

const AboutAlumniupdateGoals = () => {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(ContentState.createFromText("Organize alumni meetups and reunions.\nCreate regional alumni chapters.\nOffer career mentorship programs.\nProvide scholarships and internships."))
  );

  // Handle text formatting (bold, italic, underline)
  const handleKeyCommand = (command) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      setEditorState(newState);
      return "handled";
    }
    return "not-handled";
  };

  // Apply inline styles
  const toggleInlineStyle = (style) => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, style));
  };

  // Apply block styles
  const toggleBlockType = (blockType) => {
    setEditorState(RichUtils.toggleBlockType(editorState, blockType));
  };

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow-md rounded-md">
      <h1 className="text-lg font-semibold mb-4">Update Goals</h1>

      {/* Toolbar */}
      <div className="flex items-center space-x-3 border-b pb-2 mb-4">
        <select
          className="border px-2 py-1 rounded text-sm bg-gray-100"
          onChange={(e) => toggleBlockType(e.target.value)}
        >
          <option value="unstyled">Normal</option>
          <option value="header-one">Header 1</option>
          <option value="header-two">Header 2</option>
        </select>
        <button
          onClick={() => toggleInlineStyle("BOLD")}
          className="px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
        >
          <b>B</b>
        </button>
        <button
          onClick={() => toggleInlineStyle("ITALIC")}
          className="px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200 italic"
        >
          I
        </button>
        <button
          onClick={() => toggleInlineStyle("UNDERLINE")}
          className="px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200 underline"
        >
          U
        </button>
        <button
          onClick={() => toggleBlockType("unordered-list-item")}
          className="px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
        >
          • List
        </button>
        <button
          onClick={() => toggleBlockType("ordered-list-item")}
          className="px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
        >
          1. List
        </button>
      </div>

      {/* Editor */}
      <div
        className="border p-3 rounded bg-gray-50 min-h-[150px]"
        onClick={() => document.querySelector(".DraftEditor-root").focus()}
      >
        <Editor
          editorState={editorState}
          onChange={setEditorState}
          handleKeyCommand={handleKeyCommand}
        />
      </div>

      <button
        onClick={() => console.log(editorState.getCurrentContent().getPlainText())}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Save
      </button>
    </div>
  );
};


export default AboutAlumniupdateGoals
